<template>
  <div class="container">
    <div class="main">
      <div class="title" > DIXCEL联合ChinaAutoSalon举办DIXCEL赴日车模选拔 </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2013-7-19</div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> DIXCEL与ChinaAutoSalon(简称CAS)及露梵娜传媒合作，将在9月13-15日的CAS期间举办【DIXCEL赴日车模选拔】的活动。</div>  
        <div style="text-indent:30px"> 届时将通过网络票选http://www.cn-autosalon.com/2013girl/及现场评选选出2-4位优质模特赴日进行赛事交流及观光。签证及赴日所有费用将由DIXCEL所承担。</div>  
        <div style="text-indent:30px"> 2011年，DIXCEL也和CAS合作，将双胞胎模特朱雯、朱静成功引入日本参加日本赛事活动。促进了中日的交流，也为她们的履历写下了浓重的一笔。现如今，朱雯、朱静已经成为了上海乃至中国模特界、时尚界的香饽饽，各品牌争相邀其代言、参加各类活动。可以说，通过DIXCEL的赴日活动及CAS的模特选拔等历练，帮助她们完成了自己的梦想，也为立志走上时尚道路的模特们指引了一条道路。</div>  
        <div style="text-indent:30px"> 图为2011CAS模特选拔中获得优胜的朱雯与朱静在日本活动的照片 </div>  
      </div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2013_07_19/img1.png')"
          fit="fit">
        </el-image>
      </div>

    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return{

        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>